import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "15", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14.6 13.5-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10.27 16-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14.6 16.5-.87-.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10.27 14-.87-.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileCog2";
const FileCog2 = memo(themed(Icon));
export {
  FileCog2
};
//# sourceMappingURL=file-cog-2.js.map
